// removed by extract-text-webpack-plugin
module.exports = {"login-page-level-heading-wrapper":"PageLevelHeading__login-page-level-heading-wrapper","loginPageLevelHeadingWrapper":"PageLevelHeading__login-page-level-heading-wrapper","page-level-heading-with-icon":"PageLevelHeading__page-level-heading-with-icon","pageLevelHeadingWithIcon":"PageLevelHeading__page-level-heading-with-icon","page-level-heading-modal":"PageLevelHeading__page-level-heading-modal","pageLevelHeadingModal":"PageLevelHeading__page-level-heading-modal"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelHeading/PageLevelHeading.scss
// module id = 1521
// module chunks = 8